import React, { useContext, useEffect, useState } from 'react';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { Button, DialogActions, DialogContentText, MenuItem, Select } from '@mui/material';
import { api } from 'services/api';
import * as S from './ModalPassword.style';

interface Tprops {
  path: string;
  id: string;
  open: boolean;
  setOpen: (boolean) => void;
  isAdmin?: boolean;
}

const ModalPassword = ({ path, id, open, setOpen, isAdmin = false }: Tprops) => {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction }: any = useContext(LoadingContext);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState(false);
  const [email, setEmail] = useState('');
  const [user, setUser] = useState<any>({});
  const [role, setRole] = useState('');

  const handleClose = () => {
    setCurrentPassword('');
    setPassword('');
    setConfirmPassword('');
    setEmail('');
    setRole('');
    setPasswordError(false);
    setEmailError(false);
    setUser({});
    setOpen(false);
  };

  const isValidEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const updatePass = async () => {
    await api
      .patch(`/usuario/${path}/${id}`, { password: password, currentPassword: currentPassword })
      .then((resp) => {
        setLoadingMensagem(resp.mensagem);
        setLoadingAction(handleClose());
        setLoadingBtn('OK');
      })
      .catch((e) => {
        const msg = Array.isArray(e.response.data.message) ? e.response.data.message[0] : e.response.data.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const updateEmailOrPermission = async () => {
    await api
      .patch(`/usuario/${user.id}`, { email: email, permissions: Array.isArray(role) ? role : [role] })
      .then(() => {
        setLoadingMensagem('Alterado com Sucesso!');
        setLoadingAction(handleClose());
        setLoadingBtn('OK');
      })
      .catch((e) => {
        const msg = Array.isArray(e.response.data.message) ? e.response.data.message[0] : e.response.data.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const handleClick = async () => {
    let semaforo = false;
    setLoading(true);

    if (!isValidEmail()) {
      setEmailError(true);
      setLoading(false);
      return;
    }

    if (password !== '') {
      semaforo = true;
      if (isAdmin && currentPassword === '') {
        setCurrentPasswordError(true);
        setLoading(false);
        return;
      }
      await updatePass();
    }

    if (email !== user.email || role !== user.permissions) {
      semaforo = true;
      await updateEmailOrPermission();
      return;
    }

    if (!semaforo) {
      setLoadingMensagem('Nem uma alteração feita!');
      setLoadingAction(handleClose());
      setLoadingBtn('OK');
    }
  };

  const loadUser = async () => {
    setLoading(true);
    await api
      .get(`/usuario/vendedor/${id}`)
      .then((resp) => {
        if (!resp.status) {
          const msg = Array.isArray(resp.mensagem) ? resp.mensagem[0] : resp.mensagem;
          setLoadingMensagem(msg);
          setLoadingBtn('OK');
          return;
        }
        setUser(resp.mensagem); // Update this line to setUser(resp.data)
        setEmail(resp.mensagem.email);
        setRole(resp.mensagem.permissions);
        setLoading(false);
      })
      .catch((e) => {
        const msg = Array.isArray(e.response.data.message) ? e.response.data.message[0] : e.response.data.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const handlePasswordChange = () => {
    if (password !== confirmPassword) {
      setPasswordError(true);
    } else {
      handleClick();
    }
  };

  useEffect(() => {
    if (email.length < 2 && open) {
      loadUser();
    }
  }, [open]);

  return (
    <S.StyledDialog open={open} onClose={handleClose} aria-labelledby="change-password-dialog-title">
      <S.DialogHeader>
        <S.DialogTitle>Gerenciar Usuário</S.DialogTitle>
      </S.DialogHeader>
      <S.textoPequeno>
        <div>
          Se você deseja fazer alguma alteração nas credenciais, por favor, edite os campos abaixo e, em seguida, clique
          no botão &quot;Salvar&quot; para confirmar as modificações.
        </div>
      </S.textoPequeno>
      <S.StyledDialogContent>
        {!isAdmin && (
          <DialogContentText>
            <S.StyledTextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              helperText={emailError ? 'Email inválido!' : ''}
              error={emailError}
              fullWidth
              required
            />
          </DialogContentText>
        )}
        {!isAdmin && (
          <DialogContentText>
            <S.StyledFormControl fullWidth>
              <S.StyledInputLabel>Permissão</S.StyledInputLabel>
              <Select value={role} onChange={(e) => setRole(e.target.value)} fullWidth required>
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Vendedor">Vendedor</MenuItem>
              </Select>
            </S.StyledFormControl>
          </DialogContentText>
        )}

        {isAdmin && (
          <DialogContentText>
            <S.StyledTextField
              label="Senha atual"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              fullWidth
              required
              error={currentPasswordError}
              helperText={currentPasswordError ? 'Formato inválido!' : ''}
            />
          </DialogContentText>
        )}
        <DialogContentText>
          <S.StyledTextField
            label="Nova senha"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
          />
        </DialogContentText>
        <DialogContentText>
          <S.StyledTextField
            label="Confirme a senha"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            required
            error={passwordError}
            helperText={passwordError ? 'Senhas diferentes!' : ''}
          />
        </DialogContentText>
      </S.StyledDialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handlePasswordChange} color="primary">
          Salvar
        </Button>
      </DialogActions>
    </S.StyledDialog>
  );
};

export default ModalPassword;
